 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account.index":"account.index","auth.login":"auth.login","auth.newpassword":"auth.newpassword","auth.recover":"auth.recover","auth.signup":"auth.signup","customer":"customer","dashboard":"dashboard","estico.create":"estico.create","estico.index":"estico.index","estico.show":"estico.show","layout.auth":"layout.auth","layout.painel":"layout.painel","orders.index":"orders.index","orders.show":"orders.show","settings~store":"settings~store","settings":"settings","store":"store","subscription.charge.show":"subscription.charge.show","subscription.checkout":"subscription.checkout","subscription.my":"subscription.my","subscription.plan":"subscription.plan"}[chunkId]||chunkId) + "." + {"account.index":"3bcce26b","auth.login":"a1e34ad5","auth.newpassword":"c8b1c5b6","auth.recover":"41fde8d6","auth.signup":"fc0c34c1","chunk-1567b721":"43a29f14","chunk-1cb0e00a":"766548eb","chunk-1e866db6":"a82f8486","chunk-2d0b39fd":"c6caca92","chunk-2d0c8667":"255247e2","chunk-2d0c9158":"739d6f78","chunk-2d0cf123":"b945841a","chunk-2d0d5fa1":"c913d8f8","chunk-2d0db086":"af64cbb0","chunk-2d0e55e5":"5a32dd72","chunk-2d209639":"55948fa9","chunk-2d2106ac":"e2ddb7df","chunk-2d213392":"df40789b","chunk-2d213734":"f8b88bfb","chunk-2d21e19c":"3135c7d5","chunk-2d22292c":"5678402e","chunk-2d225997":"653dc5fb","chunk-2d237c86":"f7188da2","chunk-3c28a94e":"abdb0d69","customer":"f24545c8","dashboard":"cd710d20","estico.create":"61e8d2aa","estico.index":"6b4989d7","estico.show":"e0af1fe0","layout.auth":"48735cad","layout.painel":"5f9f49df","orders.index":"41a77124","orders.show":"98b0ac00","settings~store":"bd03def8","settings":"b8c47381","store":"caadc615","subscription.charge.show":"2a6cf4b3","subscription.checkout":"88c298e3","subscription.my":"53c75f11","subscription.plan":"04533e63"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"layout.auth":1,"layout.painel":1,"store":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account.index":"account.index","auth.login":"auth.login","auth.newpassword":"auth.newpassword","auth.recover":"auth.recover","auth.signup":"auth.signup","customer":"customer","dashboard":"dashboard","estico.create":"estico.create","estico.index":"estico.index","estico.show":"estico.show","layout.auth":"layout.auth","layout.painel":"layout.painel","orders.index":"orders.index","orders.show":"orders.show","settings~store":"settings~store","settings":"settings","store":"store","subscription.charge.show":"subscription.charge.show","subscription.checkout":"subscription.checkout","subscription.my":"subscription.my","subscription.plan":"subscription.plan"}[chunkId]||chunkId) + "." + {"account.index":"31d6cfe0","auth.login":"31d6cfe0","auth.newpassword":"31d6cfe0","auth.recover":"31d6cfe0","auth.signup":"31d6cfe0","chunk-1567b721":"31d6cfe0","chunk-1cb0e00a":"31d6cfe0","chunk-1e866db6":"31d6cfe0","chunk-2d0b39fd":"31d6cfe0","chunk-2d0c8667":"31d6cfe0","chunk-2d0c9158":"31d6cfe0","chunk-2d0cf123":"31d6cfe0","chunk-2d0d5fa1":"31d6cfe0","chunk-2d0db086":"31d6cfe0","chunk-2d0e55e5":"31d6cfe0","chunk-2d209639":"31d6cfe0","chunk-2d2106ac":"31d6cfe0","chunk-2d213392":"31d6cfe0","chunk-2d213734":"31d6cfe0","chunk-2d21e19c":"31d6cfe0","chunk-2d22292c":"31d6cfe0","chunk-2d225997":"31d6cfe0","chunk-2d237c86":"31d6cfe0","chunk-3c28a94e":"31d6cfe0","customer":"31d6cfe0","dashboard":"31d6cfe0","estico.create":"31d6cfe0","estico.index":"31d6cfe0","estico.show":"31d6cfe0","layout.auth":"8fea3f97","layout.painel":"18505303","orders.index":"31d6cfe0","orders.show":"31d6cfe0","settings~store":"31d6cfe0","settings":"31d6cfe0","store":"1cb5dc56","subscription.charge.show":"31d6cfe0","subscription.checkout":"31d6cfe0","subscription.my":"31d6cfe0","subscription.plan":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
